import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";

/* This class represents a lead of type More Information for a basic listing. */
export default class BasicListingInformationLeadBasic {
    constructor(formData) {
      this.type = 'postBasicListingBrochureBasic';
      this.xxTrustedFormCertUrl = formData.xxTrustedFormCertUrl;
      this.listingId = formData.id;
      this.comments = formData.comments;
      this.includeRecommendations = formData.includeRecommended;
      this.mailAddress = formData.email;
      this.name = formData.name;
      this.userPhoneNumber = formData.phone;
      this.leadAction = formData.leadAction;
      this.fromPage = formData.fromPage;
      this.excludeRecommendations = formData.excludeRecommendations;
      this.guid = formData.guid;
  
      if (formData.postalCode) {
        this.userPostalCode = formData.postalCode;
      } else {
        this.livesOutside = true;
      }
    }

    setHousingInformation(properties) {
      this.marketId = properties.marketId;
      this.marketName = properties.marketName;
    }

    static getLeadSubmitedAnalyticsData() {
      return new GoogleAnalyticsEvent("TDV Events", "Direct Leads", "Search-CTA-Learn-More")
    }
  }